<template>
  <div>
    <Head title="Create Company" />
    <h1 class="mb-8 text-3xl font-bold">
      <Link class="text-blue-400 hover:text-blue-600" :href="`/companies/${company.id}/edit`">{{ company.name }}</Link>
      <span class="text-blue-400 font-medium">/</span> Create Team
    </h1>
    <div class="max-w-3xl bg-white  shadow overflow-hidden">
      <form @submit.prevent="store">
        <div class="flex flex-wrap -mb-8 -mr-6 p-8">
          <text-input v-model="form.name" :error="form.errors.name" class="pb-8 pr-6 w-full lg:w-1/2" label="Name" />
        </div>
        <div class="flex items-center justify-end px-8 py-4 bg-gray-50 border-t border-gray-100">
          <loading-button :loading="form.processing" class="btn-blue" type="submit">Create Team</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/vue3'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import LoadingButton from '@/Shared/LoadingButton'

export default {
  components: {
    Head,
    Link,
    LoadingButton,
    TextInput,
  },
  layout: Layout,
  remember: 'form',
  props:{
    company: Object,
  },
  data() {
    return {
      form: this.$inertia.form({
        name       : null,
      }),
    }
  },
  methods: {
    store() {
      this.form.post(`/teams/${this.company.id}`)
    },
  },
}
</script>
